import Vue from 'vue'
import createAxiosInstance from './createAxiosInstance'
import jwtDecode from 'jwt-decode'

// JWT Token 處理相關變數
let isFetchingToken = false
let pendingPromises = []

/**
 * JWT Token 處理器
 * 統一管理 JWT Token 的取得與更新邏輯
 * 避免多個 API 同時請求時重複索取 Token
 */
const jwtTokenHandler = () => {
  return new Promise((resolve, reject) => {
    // 如果同時有其他token正在取得中，則先等待它完成再判斷，以避免重複打api
    if (isFetchingToken) {
      pendingPromises.push({ resolve, reject })
      return
    }

    // 完全沒 token、過期了則取得Token
    // Housekeeper沒有設定jwtDue，因此若為Housekeeper取得的token，來mgmt一律重新取
    if (!Vue.prototype.$getCookie('JwtToken') || !localStorage.getItem('jwtDue') || parseInt(localStorage.getItem('jwtDue')) < Date.now()) {
      isFetchingToken = true
      getJwtToken()
        .then(() => {
          resolvePendingPromises()
          resolve()
        })
        .catch((error) => {
          rejectPendingPromises(error)
          reject(error)
        })
      return
    }

    // 還沒過期，則繼續使用原本的 jwtToken
    resolve()
  })
}

const getJwtToken = async () => {
  // jwtToken 使用 createAxiosInstance 來做為基底，以利支援統一的登入過期處理
  const instance = createAxiosInstance(process.env.VUE_APP_HOUSEKEEPER_WEB_URL)
  try {
    const webCookie = Vue.prototype.$getCookie('comLoginToken').split('token=').pop()
    const res = await instance.post('/api/v1/Identity/Login/Admin/WebCookie', {}, {
      headers: {
        webCookie,
        'x-requestid': Vue.prototype.$getGuid()
      }
    })
    // mgmt 的 cookie 是掛在 /mgmt，而 housekeeper 是掛在 /
    // 不清楚為什麼過去會這麼做，但暫時先做沿用，分開管理jwtToken，減少管理難度
    const path = process.env.NODE_ENV === 'development' ? '/' : '/mgmt'
    document.cookie = 'JwtToken=Bearer ' + res.data.AccessToken + `; path=${path}`
    const decodedToken = jwtDecode(res.data.AccessToken)
    localStorage.setItem('jwtDue', decodedToken.exp * 1000)
  } finally {
    isFetchingToken = false
  }
}

const resolvePendingPromises = () => {
  pendingPromises.forEach(p => p.resolve())
  pendingPromises = []
}

const rejectPendingPromises = (error) => {
  pendingPromises.forEach(p => p.reject(error))
  pendingPromises = []
}

export { jwtTokenHandler }
